import { CardStatus, QuickFilter } from '../constants/app.constants';
import { UiFilterState, UiState } from '../models/app-state.model';
import { ValidationResult } from './validation-result.model';

export function validateUiState(uiState: UiState): ValidationResult {
  const errors: string[] = [];

  errors.push(...validateUiFilterState(uiState.ladder, 'UI ladder filter').errors);
  errors.push(...validateUiFilterState(uiState.allCards, 'UI all cards filter').errors);

  return { isValid: errors.length === 0, errors };
}

export function validateUiFilterState(
  filter: UiFilterState,
  fieldPrefix: string,
): ValidationResult {
  const errors: string[] = [];

  if (typeof filter?.textQuery !== 'string') {
    errors.push(`${fieldPrefix} text query must be a string.`);
  }

  if (filter?.status !== 'ALL' && !Object.values(CardStatus).includes(filter?.status as CardStatus)) {
    errors.push(`${fieldPrefix} status is invalid.`);
  }

  if (filter?.categoryId !== null && typeof filter?.categoryId !== 'string') {
    errors.push(`${fieldPrefix} category reference must be a string or null.`);
  }

  if (!Object.values(QuickFilter).includes(filter?.quickFilter)) {
    errors.push(`${fieldPrefix} quick filter is invalid.`);
  }

  return { isValid: errors.length === 0, errors };
}